import { render, staticRenderFns } from "./PatientStatistics.vue?vue&type=template&id=475867a8&"
import script from "./PatientStatistics.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PatientStatistics.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('475867a8')) {
      api.createRecord('475867a8', component.options)
    } else {
      api.reload('475867a8', component.options)
    }
    module.hot.accept("./PatientStatistics.vue?vue&type=template&id=475867a8&", function () {
      api.rerender('475867a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/common/PatientStatistics.vue"
export default component.exports